import React from 'react';
import GlobalStyles from '@mui/material/GlobalStyles';

export default function ScrollbarStyle() {

    return (
        <GlobalStyles
            styles={{
                '*::-webkit-scrollbar': {
                    width: '9px',
                    height:'9px',
                },
                '*::-webkit-scrollbar-thumb': {
                    backgroundImage: 'linear-gradient(45deg, rgb(68, 109, 89), rgb(40, 81, 61))',
                    borderRadius: '10px',
                },
                '*::-webkit-scrollbar-thumb:hover': { 
                    backgroundImage: 'linear-gradient(45deg, rgb(178, 235, 177), rgb(48, 89, 69))',
                },
                '*::-webkit-scrollbar-thumb:active': { 
                    backgroundImage: 'linear-gradient(45deg, rgb(178, 235, 177), rgb(178, 235, 177))',
                },
                '*::-webkit-scrollbar-corner': { 
                    background: 'rgba(28, 32, 37, 1)'
                },
            }}
        />
    );
}


// import React from 'react';
// import GlobalStyles from '@mui/material/GlobalStyles';

// export default function ScrollbarStyle() {

//     return (
//         <GlobalStyles
//             styles={{
//                 '*::-webkit-scrollbar': {
//                     width: '9px',
//                     height:'9px',
//                 },
//                 '*::-webkit-scrollbar-thumb': {
//                     backgroundImage: 'linear-gradient(45deg, rgb(52, 155, 235), rgb(52, 98, 235))',
//                     borderRadius: '10px',
//                 },
//                 '*::-webkit-scrollbar-thumb:hover': { 
//                     backgroundImage: 'linear-gradient(45deg, rgb(51, 120, 235), rgb(52, 98, 235))',
//                 },
//                 '*::-webkit-scrollbar-thumb:active': { 
//                     backgroundImage: 'linear-gradient(45deg, rgb(41, 82, 196), rgb(41, 82, 196))',
//                 },
//                 '*::-webkit-scrollbar-corner': { 
//                     background: 'rgba(28, 32, 37, 1)'
//                 },
//             }}
//         />
//     );
// }